import "./lib/sentry"; // Must be first import
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";

const isLovablePreviewHost =
  typeof window !== "undefined" &&
  window.location.hostname.endsWith(".lovable.app") &&
  window.location.hostname.includes("preview");

const PREVIEW_CACHE_RESET_KEY = "wellebit-preview-cache-reset";

function renderApp() {
  createRoot(document.getElementById("root")!).render(<App />);
}

async function bootstrap() {
  renderApp();

  if (!isLovablePreviewHost) return;

  try {
    if (sessionStorage.getItem(PREVIEW_CACHE_RESET_KEY) === "done") return;
    sessionStorage.setItem(PREVIEW_CACHE_RESET_KEY, "done");

    let didResetPreviewState = false;

    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      if (registrations.length > 0) {
        await Promise.all(registrations.map((registration) => registration.unregister()));
        didResetPreviewState = true;
      }
    }

    if ("caches" in window) {
      const cacheKeys = await caches.keys();
      if (cacheKeys.length > 0) {
        await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
        didResetPreviewState = true;
      }
    }

    if (didResetPreviewState) {
      window.location.reload();
    }
  } catch (error) {
    console.warn("[PreviewBootstrap] Failed to reset preview cache state", error);
  }
}

bootstrap();
